import axios from 'axios';
import config from 'config';
import { setupRequestInterceptors } from './interceptors';

const instance = axios.create({ baseURL: `${config.API_BASE_URL}/users` });
const request = setupRequestInterceptors(instance);

const api = {
  getCurrentUser: async () => {
    const response = await request.get('/current');
    const { data } = response;
    return data;
  },
  getUserById: async (id, options) => {
    const { data } = await request.get(`/${id}`, options);
    return data;
  },
  updateUser: async (id, payload) => {
    const response = await request.put(`/${id}`, payload);
    const { data } = response;
    return data;
  },
  addUser: async (params) => {
    const response = await request.post(``, params);
    const { data } = response;
    return data;
  },
  resendConfirmationEmail: async (payload) => {
    const response = await request.post(`/resend-confirmation`, payload);
    const { data } = response;
    return data;
  },
  resendInvite: async (payload) => {
    const response = await request.post(`/admin/resend-invite`, payload);
    const { data } = response;
    return data;
  },
  changeUserName: async (payload) => {
    const response = await request.post(`/change-username`, payload);
    const { data } = response;
    return data;
  },
  adminCreateUser: async (params) => {
    const response = await request.post(`/admin`, params);
    const { data } = response;
    return data;
  },
  getRolesByTeam: async (ids) => {
    const response = await request.get(`/admin/internal/search/advanced?teamIds=${ids}`);
    const { data } = response;
    return data;
  },
  adminGetUserById: async (username) => {
    if (!username) return null;

    const response = await request.get(`/admin/${username}`);
    const { data } = response;
    return data;
  },
  adminUpdateUser: async (params) => {
    const response = await request.put(`/admin`, params);
    const { data } = response;
    return data;
  },
  resetPassword: async (username) => {
    const response = await request.post(`/reset-password/${username}`);
    const { data } = response;
    return data;
  },
  activateProviderUser: async (payload) => {
    const { data } = await request.post('/providers/activate', payload);
    return data;
  },
  searchNgFamilyEmail: async (email) => {
    const { data } = await request.get('/families/search', {
      params: { email: String(email || '').toLowerCase() },
    });
    return data;
  },
};
export { request };
export default api;